module.exports = __webpack_public_path__ + "files/4cb346f527312a220682c943f8c35073.png";